import React from "react";
import { Input } from "@/components/ui/input";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { Field, NumberInput, PanelSection } from "./controls";

const FONT_FAMILIES = ["IBM Plex Sans", "IBM Plex Mono", "Georgia", "Arial", "Courier New", "Impact"];
const FONT_WEIGHTS = ["400", "500", "600", "700", "800"];
const ANCHORS = ["start", "middle", "end"];

export default function TextControls({ attrs, setAttr }) {
  return (
    <PanelSection title="Content">
      <div className="space-y-2">
        <Field label="Text">
          <Input
            value={attrs.text || ""}
            onChange={(e) => setAttr("text", e.target.value)}
            data-testid="attr-text-input"
            className="h-8 rounded-none bg-chrome border-line text-foreground text-sm"
          />
        </Field>
        <Field label="Font Family">
          <Select value={attrs.fontFamily || "IBM Plex Sans"} onValueChange={(v) => setAttr("fontFamily", v)}>
            <SelectTrigger data-testid="attr-fontFamily-select" className="h-8 rounded-none bg-chrome border-line text-foreground text-sm">
              <SelectValue />
            </SelectTrigger>
            <SelectContent className="bg-chrome border-line text-foreground rounded-none">
              {FONT_FAMILIES.map((f) => (
                <SelectItem key={f} value={f}>{f}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </Field>
        <div className="grid grid-cols-2 gap-2">
          <Field label="Weight">
            <Select value={String(attrs.fontWeight || "400")} onValueChange={(v) => setAttr("fontWeight", v)}>
              <SelectTrigger data-testid="attr-fontWeight-select" className="h-8 rounded-none bg-chrome border-line text-foreground text-sm">
                <SelectValue />
              </SelectTrigger>
              <SelectContent className="bg-chrome border-line text-foreground rounded-none">
                {FONT_WEIGHTS.map((w) => (
                  <SelectItem key={w} value={w}>{w}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </Field>
          <Field label="Letter Sp.">
            <NumberInput value={attrs.letterSpacing} step={0.5} onChange={(v) => setAttr("letterSpacing", v)} testId="attr-letterSpacing-input" />
          </Field>
        </div>
        <Field label="Align">
          <Select value={attrs.textAnchor || "start"} onValueChange={(v) => setAttr("textAnchor", v)}>
            <SelectTrigger data-testid="attr-textAnchor-select" className="h-8 rounded-none bg-chrome border-line text-foreground text-sm">
              <SelectValue />
            </SelectTrigger>
            <SelectContent className="bg-chrome border-line text-foreground rounded-none">
              {ANCHORS.map((a) => (
                <SelectItem key={a} value={a}>{a}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </Field>
      </div>
    </PanelSection>
  );
}
